"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideTab = exports.SideTabsWidget = exports.SideTabsPaneWidget = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
/**
 * A composition widget which can be used to combine a `SideTabsWidget` with a content pane that the tabs control.
 * The correct ARIA attributes between the tab list and pane are applied automatically.
 *
 * There are two ways to provide the pane content:
 * * Controlled mode: If one child is provided, it will be rendered as the pane content. Update it in response to the `onChangeTab` prop on `tablist`.
 * * Uncontrolled mode: If an array of children is provided, they will be mapped into the list of tabs,
 *    i.e. `children[2]` will be rendered in the pane when tab index `2` is selected. In this case the widget will handle the selection state
 *    internally.
 *
 * Dimensions may be constrained via the usual routes, e.g. `style={{ height: 300, width: 600 }}`.
 * Both the side tabs and the content pane will scroll if they exceed the height of the overall widget.
 */
var SideTabsPaneWidget = function (_a) {
    var testId = _a.testId, props = tslib_1.__rest(_a, ["testId"]);
    return React.createElement(TableauUI.SideTabsPane, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, exports.SideTabsPaneWidget.displayName) }, props));
};
exports.SideTabsPaneWidget = SideTabsPaneWidget;
exports.SideTabsPaneWidget.displayName = 'SideTabsPaneWidget';
/**
 * A side (vertical) tabs widget. Generally expected to be used inside of a `SideTabsPaneWidget` but may be used separately if necessary.
 *
 * One of `aria-label` or `aria-labelledby` must be provided.
 * When used outside of a `SideTabsPaneWidget`, `aria-controls` must be added to each individual `SideTab`.
 */
// eslint-disable-next-line deprecation/deprecation
var SideTabsWidget = function (_a) {
    var testId = _a.testId, props = tslib_1.__rest(_a, ["testId"]);
    return React.createElement(TableauUI.SideTabs, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, exports.SideTabsWidget.displayName) }, props));
};
exports.SideTabsWidget = SideTabsWidget;
exports.SideTabsWidget.displayName = 'SideTabsWidget';
/** Accessibility requirements prohibit tooltips or other interactive content inside of a Tab. */
var SideTab = function (_a) {
    var testId = _a.testId, props = tslib_1.__rest(_a, ["testId"]);
    return React.createElement(TableauUI.SideTab, tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "data-tb-test-id": Declarative_1.makeTestId(testId, exports.SideTab.displayName) }, props));
};
exports.SideTab = SideTab;
exports.SideTab.displayName = 'SideTab';
//# sourceMappingURL=SideTabsWidget.js.map